<!--
  EntityInputTags.vue — the `entity-input-tags` widget (also serves
  `multi_employee` and driver_license_cats). A chips combobox binding an array.

  Reconstructed from lacak.io deployed behavior; app-specific contract verbatim
  (props value/field/rules/disabled/label; emits `input` an array; free-entry
  tags vs. fixed items from field.params.items), internal impl re-authored on
  the Vuetify 1.5 v-combobox.
-->
<template>
  <v-combobox
    :value="arrayValue"
    :items="items"
    :item-value="itemValue"
    :item-text="itemText"
    :label="resolvedLabel"
    :rules="rules"
    :disabled="disabled"
    :required="required"
    multiple
    chips
    deletable-chips
    small-chips
    @input="$emit('input', $event)"
  />
</template>

<script>
export default {
  name: 'entity-input-tags',
  props: {
    value: { default: null },
    field: { type: Object, default: () => ({}) },
    rules: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: '' },
  },
  computed: {
    params() { return (this.field && this.field.params) || {}; },
    items() { return this.params.items || []; },
    itemValue() { return this.params.itemValue || 'id'; },
    itemText() { return this.params.itemText || 'label'; },
    required() { return !!(this.field && this.field.required); },
    resolvedLabel() { return this.label || (this.field && this.field.label) || ''; },
    arrayValue() { return Array.isArray(this.value) ? this.value : []; },
  },
};
</script>
